import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector } from 'Store/selectors';
import { goPopup } from 'Store/actions/portalModalActions';
import { getGroups } from 'Store/selectors';
import * as actionLayer from '../../modules/GroupsActions';
import DeleteGroupPopup from './DeleteGroupPopup';

const mapDispatchToProps = (dispatch) => ({
	deleteGroup: (groupId) =>
		dispatch(
			actionLayer.deleteGroup.request({
				...groupId,
			})
		),
	closeModal: () => dispatch(goPopup('')),
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	isLoading: nullSafe(() => getGroups(state, 'isLoading'), false),
	payload: nullSafe(() => portalModalSelector(state).data.payload, false),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(DeleteGroupPopup);
